import { SupportedLanguage, supportedLanguages } from "../types/lang.type";

export function localizedURL(url: string, lang: SupportedLanguage): string {
  if (lang === 'en') {
    return url;
  }
  return `/${lang}${url === '/' ? '' : url}`;
}

export function langPart(lang: SupportedLanguage): string {
  return lang === 'en' ? '' : `/${lang}`;
}

export function isOriginalURL(url: string): boolean {
  const urlParts = url.split('/');
  return !urlParts.some(part => supportedLanguages.includes(part as SupportedLanguage));
}
